import React from 'react';
import PropTypes from 'prop-types';

class EnvSplit extends React.Component {
  static propTypes = {
    browser: PropTypes.func,
    server: PropTypes.func,
  };

  componentDidMount() {
    if (typeof window !== 'undefined') {
      // only show after initial render so we don't get a dom mismatch error
      this.isBrowser = true;
      this.forceUpdate();
    }
  }

  render() {
    if (this.isBrowser) {
      return this.props.browser && this.props.browser() || null;
    }
    return this.props.server && this.props.server() || null;
  }
}

export default EnvSplit;

export function browserOnly(Component) {
  return props => <EnvSplit browser={() => <Component {...props} />} />;
}

export function serverOnly(Component) {
  return props => <EnvSplit server={() => <Component {...props} />} />;
}

export function jsOnly(Component) {
  return props => <div className="js-only"><Component {...props} /></div>;
}



// WEBPACK FOOTER //
// ./spa/Components/EnvSplit.jsx